import { SwitchAccountPage } from '@online-webinar/account';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/switch-account'].update({
        staticData: { title: { page: 'AccountSwitch.PageHeading' } },
        component: authGuard(SwitchAccountPage)
    });
};
